import React, { useEffect, useState } from 'react'
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { Formik } from 'formik';
import Write from 'asset/SvgComponent/Write'
import Delete from 'asset/SvgComponent/Delete'
import EditIcon from 'asset/SvgComponent/EditIcon'
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import axios from 'api/index'
import { IAPI_Response } from 'api/types'
import { 
  API_ENDPOINT,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  TEXT
} from 'utils/globalConstant'
import { validationSchema } from './validationSchema'
import { IDesignation, IList, IItem } from './types'
import moment from "moment"

export default function Index() {
  const [currentPage, setCurrentPage] = React.useState(0)
  const [lastPage, setLastPage] = React.useState(0)
  const [itemsPerPage, setPerPage] = React.useState(10)
  const [itemsCount, setItemCount] = React.useState(0)
  const [from, setFrom] = React.useState(0)

  const [validation, setValidation] = React.useState('')
  const [error, setError] = React.useState('')
  const [success, setSuccess] = React.useState('')
  const [showError, setShowError] = React.useState(false)
  const [showSuccess, setShowSuccess] = React.useState(false)
  const [showLoading, setShowLoading] = React.useState(false)

  const [showCreate, setShowCreate] = React.useState(false)
  const handleCloseCreate = () => setShowCreate(false)
  const handleShowCreate = () => setShowCreate(true)

  const [showEdit, setShowEdit] = React.useState(false)
  const handleCloseEdit = () => setShowEdit(false)
  const handleShowEdit = () => setShowEdit(true)

  const [showConfirm, setShowConfirm] = React.useState(false)
  const handleCloseConfirm = () => setShowConfirm(false)
  const handleShowConfirm = (id: any) => {
    setShowConfirm(true)
    setItem({
      designation_id: id,
      designation_name: '',
      order: 0
    })
  }

  const [lists, setData] = useState<IList[]>([])
  const [item, setItem] = useState<IItem>({
    designation_id: 0,
    designation_name: '',
    order: 0
  })
  const [dateFormat, setDateFormat] = useState('')

  const formatNumber = (i: number) => {
    const j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }

    if(i == 0){
      return '-';
    }
    return i + "th";
  }

  const getDesignation = async (page_number: null | number) => {
    setShowLoading(true)
    try {
      const res = await axios.get<IAPI_Response<IDesignation>>(API_ENDPOINT.GET_DESIGNATION, {
        params: {
          page: page_number,
        },
      })
      const result = await res
      if (result?.data?.results?.data?.length) {
        setData(result?.data?.results?.data)
        setCurrentPage(result?.data?.results?.current_page)
        setLastPage(result?.data?.results?.last_page)
        setPerPage(result?.data?.results?.per_page)
        setItemCount(result?.data?.results?.total)
        setFrom(result?.data?.results?.from)
      }
      setShowLoading(false)
    } catch {
      setShowError(true)
      setError(ERROR_MESSAGE.SYSTEM_ERROR)
    }
  }

  const showDesignation = async (id: null | number) => {
    try {
      const response = await axios.get<IAPI_Response<IItem>>(API_ENDPOINT.SHOW_DESIGNATION +'/'+ id)
      const result = await response
      if (result?.data?.results) {
        setItem(result?.data?.results)
      }
      handleShowEdit()
    } catch {
      setShowError(true)
      setError(ERROR_MESSAGE.SYSTEM_ERROR)
    }

    setTimeout(() => {
      setShowError(false)
    }, 3000);
  }

  const createDesignation = async (value: any, {resetForm} : any) => {
    await axios.post(API_ENDPOINT.POST_DESIGNATION, {
      designation_name: value.designation_name,
      order: value.order
    }).then(response => {
       if (response?.data?.status * 1 === 1) {
          setShowSuccess(true)
          setSuccess(SUCCESS_MESSAGE.DESIGNATION.CREATED)
          getDesignation(null);
       }
       resetForm({})
       handleCloseCreate();
    }).catch(error => {
       setValidation(error.response.data.message)
    })
    
    setTimeout(() => {
      setShowSuccess(false)
      setShowError(false)
      setValidation('')
    }, 3000);
  }

  const updateDesignation = async (value: any, {resetForm} : any) => {
    await axios.put(API_ENDPOINT.PUT_DESIGNATION +'/'+ value.designation_id, {
      designation_name: value.designation_name,
      order: value.order
    }).then(response => {
       if (response?.data?.status * 1 === 1) {
          setShowSuccess(true)
          setSuccess(SUCCESS_MESSAGE.DESIGNATION.UPDATED)
          getDesignation(null);
       }
       resetForm({})
       handleCloseEdit();
    }).catch(error => {
      setValidation(error.response.data.message)
    })
    
    setTimeout(() => {
      setShowSuccess(false)
      setShowError(false)
      setValidation('')
    }, 3000);
  }

  const deleteDesignation = async (id: null | number) => {
    try {
      const response = await axios.delete(API_ENDPOINT.DELETE_DESIGNATION +'/'+ id)
      const result = await response
      if (result?.data?.status * 1 === 1) {
        setShowSuccess(true)
        setSuccess(SUCCESS_MESSAGE.DESIGNATION.DELETED)
        getDesignation(null);
     }
    } catch {
      setShowError(true)
      setError(ERROR_MESSAGE.SYSTEM_ERROR)
    }
    handleCloseConfirm()
    setTimeout(() => {
      setShowSuccess(false)
      setShowError(false)
    }, 3000);
  }

  useEffect(() => {
    ;(async () => {
      getDesignation(null)
      setDateFormat(localStorage.getItem('date_format') ?? "")
    })()
  }, [])

  return (
    <>
      <Container fluid>
        <h5 className='fw-bold'>Designation</h5>
        <Breadcrumb className='breadcrumbs'>
          <Breadcrumb.Item className=' text-decoration-none' href='/home'>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item
              className=' text-decoration-none'
          >
            Setup
          </Breadcrumb.Item>
          <Breadcrumb.Item
            className=' text-decoration-none'
          >
            Employee
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Designation</Breadcrumb.Item>
        </Breadcrumb>

        <Alert 
          type="success" 
          show={showSuccess} 
          message={success} 
          setShow={() => { 
              setShowSuccess(false);
            }
          }
        />

        <Alert 
          type="error" 
          show={showError} 
          message={error} 
          setShow={() => { 
            setShowError(false);
            }
          }
        />

        <Card className='border-0  p-0 bordered-card'>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <span className='fw-bold'>Designation List</span>
              </Col>
              <Col sm={6} className='d-flex justify-content-end hidden'>
                <InputGroup size='sm' className={'w-25'}>
                  <Form.Control
                    aria-label='search'
                    aria-describedby='inputGroup-sizing-sm'
                    placeholder='Search...'
                  />
                  <InputGroup.Text className='bg-transparent search-input '>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup>
                <Button
                  onClick={handleShowCreate}
                  className=' add-new-btn rounded mx-2 text-white'
                  variant='warning'
                  >
                  <EditIcon/>
                  &nbsp;Add New Designation
                </Button>
              </Col>
            </Row>

            <Table responsive className='bordered-tabs-top mt-3'>
              <thead>
                <tr>
                  <th className='text-center' style={{ width: '10%' }}>No.</th>
                  <th className='text-center' style={{ width: '45%' }}>Designation </th>
                  <th className='text-center' style={{ width: '15%' }}>Order </th>
                  <th className={'text-center'}>Actions</th>
                </tr>
              </thead>
              <tbody>
                <>
                {lists.length > 0 ? (
                  lists.map((item, index) => (
                    <tr className='mb-2' key={index}>
                      <td>{from + index}</td>
                      <td className='fw-bold'>{item.designation_name} </td>
                      <td className='text-center'>{formatNumber(item.order)}</td>
                      <td className='text-center'>
                        <Button
                          onClick={() => showDesignation(item.designation_id)}
                          className=' p-1 pt-0 pb-0'
                          style={{ fontSize: '12px', color: 'white' }}
                          variant=' btn-transparent'
                          size='sm'
                          >
                          <Write/>
                        </Button>
                        <Button
                        onClick={() => handleShowConfirm(item.designation_id)}
                          className=' p-1 pt-0 pb-0'
                          style={{ fontSize: '12px', color: 'white' }}
                          variant=' btn-transparent'
                          size='sm'
                          >
                          <Delete/>
                        </Button>
                      </td>
                      <br />
                    </tr>
                  ))
                  ) : (
                    <tr className='no-item'>
                      <td colSpan={4}>{TEXT.NOT_FOUND}</td>
                    </tr>
                )}
                </>
              </tbody>
            </Table>

            <Pagination
              itemsCount={itemsCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              lastPage={lastPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={false}
              pageClicked={(page: number) => { 
                  getDesignation(page);
                }
              }
            />

            <Dialog 
              show={showConfirm} 
              setShow={handleCloseConfirm}
              setEvent={() => { 
                  deleteDesignation(item.designation_id)
                }
              }
            />

            <Loader show={showLoading} />
          </Card.Body>
        </Card>

        {/* ADD MODAL*/}
        <Formik
            initialValues={{ designation_name: '', order: ''}}
            validationSchema={validationSchema}
            onSubmit={createDesignation}
            >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (

            <Form id="designationCreate" noValidate onSubmit={handleSubmit}>
              <Modal className='modal' centered show={showCreate} onHide={handleCloseCreate}>
                <Modal.Header closeButton>
                  <Modal.Title>Add New Designation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row className="mb-3">
                    <Col sm={6}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted'>Designation Name</Form.Label>
                        <Form.Control
                            size={'sm'}
                            type='text'
                            placeholder='Designation name'
                            name="designation_name"
                            value={values.designation_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.designation_name && !!errors.designation_name || !!validation}
                            autoFocus />
                        {
                          validation != '' ?
                              (Object.keys(validation).map((message : any, index) => (
                                      <Form.Control.Feedback type="invalid" key={index}>
                                        {validation[message][index]}
                                      </Form.Control.Feedback>
                                  ))
                              ) : (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.designation_name}
                                  </Form.Control.Feedback>
                              )
                        }
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted'>Designation Order</Form.Label>
                        <Form.Control
                            size={'sm'}
                            type='number'
                            placeholder='Designation order'
                            name="order"
                            value={values.order}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.order && !!errors.order || !!validation}
                            autoFocus />

                          <Form.Control.Feedback type="invalid">
                            {errors.order}
                          </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='outline-primary' className='mx-2' size={'sm'} onClick={handleCloseCreate}>
                    Cancel
                  </Button>
                  <Button 
                    type="submit"
                    disabled={isSubmitting}
                    form="designationCreate" 
                    variant='primary text-white'
                    size={'sm'}
                    className='mx-2'
                    >
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          )}
        </Formik>

        {/* EDIT MODAL*/}
        <Formik
            initialValues={item}
            validationSchema={validationSchema}
            onSubmit={updateDesignation}
            enableReinitialize
            >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (

            <Form id="designationUpdate" noValidate onSubmit={handleSubmit}>
              <Modal className='modal' show={showEdit} centered onHide={handleCloseEdit}>
                <Modal.Header closeButton>
                  <Modal.Title className='fw-bold'>Edit Designation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row className="mb-3">
                    <Col sm={6}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted'>Designation Name</Form.Label>
                        <Form.Control
                            size={'sm'}
                            type='text'
                            placeholder='Designation name'
                            name="designation_name"
                            value={values.designation_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.designation_name && !!errors.designation_name || !!validation}
                            autoFocus />
                        {
                          validation != '' ?
                              (Object.keys(validation).map((message : any, index) => (
                                      <Form.Control.Feedback type="invalid" key={index}>
                                        {validation[message][index]}
                                      </Form.Control.Feedback>
                                  ))
                              ) : (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.designation_name}
                                  </Form.Control.Feedback>
                              )
                        }
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                          <Form.Label className='text-muted'>Designation Order</Form.Label>
                          <Form.Control
                              size={'sm'}
                              type='number'
                              placeholder='Designation order'
                              name="order"
                              value={values.order}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.order && !!errors.order || !!validation}
                              autoFocus />

                          <Form.Control.Feedback type="invalid">
                            {errors.order}
                          </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='outline-primary' size={'sm'} onClick={handleCloseEdit}>
                    Cancel
                  </Button>
                  <Button
                    type="submit" 
                    disabled={isSubmitting} 
                    form="designationUpdate"
                    variant='primary text-white'
                    size={'sm'}
                    className='mx-2'
                    >
                    Update
                </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          )}
        </Formik>

      </Container>
    </>
  )
}
